import { Button } from "@softmax/design-system";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { coworldLayout } from "./coworld-layout.styles";

export function CoworldVersionDetails({
  id,
  visibility,
  uploaded,
  onCopyId,
  copied,
  publicationDescription,
}: Readonly<{
  id: string;
  visibility: string;
  uploaded: string;
  onCopyId(): void;
  copied: boolean;
  publicationDescription: string;
}>) {
  return (
    <aside {...stylex.props(styles.properties)} aria-label="Version details">
      <h2 {...stylex.props(coworldLayout.heading)}>Version details</h2>
      <dl {...stylex.props(styles.facts)}>
        <div {...stylex.props(styles.fact)}>
          <dt {...stylex.props(styles.term)}>Visibility</dt>
          <dd {...stylex.props(styles.value)}>{visibility}</dd>
        </div>
        <div {...stylex.props(styles.fact)}>
          <dt {...stylex.props(styles.term)}>Uploaded</dt>
          <dd {...stylex.props(styles.value)}>{uploaded}</dd>
        </div>
      </dl>
      <details open {...stylex.props(styles.details)}>
        <summary {...stylex.props(styles.summary)}>
          Upload & publication
        </summary>
        <div {...stylex.props(coworldLayout.stack)}>
          <code {...stylex.props(coworldLayout.mono)}>{id}</code>
          <Button size="sm" variant="quiet" onClick={onCopyId}>
            {copied ? "Copied" : "Copy upload ID"}
          </Button>
          <p {...stylex.props(coworldLayout.muted)}>{publicationDescription}</p>
        </div>
      </details>
    </aside>
  );
}

const styles = stylex.create({
  properties: {
    paddingTop: spacing.space12,
    display: "grid",
    gap: spacing.space16,
    minWidth: 0,
  },
  facts: {
    display: "grid",
    gap: spacing.space12,
    margin: 0,
    fontSize: fontSizes.small,
  },
  fact: { display: "grid", gap: spacing.space4 },
  term: { color: colors.secondary },
  value: { margin: 0, overflowWrap: "anywhere" },
  details: {
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.hairline,
    paddingTop: spacing.space16,
  },
  summary: {
    cursor: "pointer",
    fontSize: fontSizes.small,
    marginBottom: spacing.space12,
  },
});
